import { Stack } from '@mui/material';
import { Box } from '@mui/system';

/**
 * 
 * @param {object} props { 
 *   imageFiles <Array<object> - // E.g. [{fileKey: "...", url: "..."}, ...]. May contain nulls.
 *   imageWidth <number>
 * } 
 * @returns React conponent
 */
export default function ImageListBox({imageFiles, imageWidth = 180}) {

    console.log('ImageListBox RENDER', imageFiles)

    return (
        <Stack direction="row" sx={{flexWrap: 'wrap', alignItems: 'center'}}>
            {
                imageFiles.map((thisImageFile) => {
                    if (!thisImageFile?.fileKey) {
                        return null
                    }
                    const {fileKey, url} = thisImageFile
                    console.log('ImageListBox RENDER returning Box with url', url)
                    return (
                        <Box key={fileKey} sx={{mr: 1, mb: 1}}>
                            {/* <Typography variant="body2" paragraph>Url: {url}</Typography> */}
                            <img src={url} alt={fileKey} width={imageWidth} style={{display: 'block'}} />
                        </Box>
                    )
                })
            }
        </Stack>
    )
}
